import script from "./ChapterModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChapterModal.vue?vue&type=script&setup=true&lang=js"

import "./ChapterModal.vue?vue&type=style&index=0&id=3def714e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3def714e"]])

export default __exports__